import { useEffect, useState } from 'react'
import {
  useProductFromQueryParam,
  insertAsteriskBetweenCharacters,
  InsertModificationArgs,
} from '../ProductsConfiguration'
import DnaTubes from './products/DnaTubes'
import useTubeValidation from '../useTubeValidation'
import { TubeProduct } from '../enum'
import useFormikHelper from '../useFormikHelper'
import { BiTubeProduct } from '../../BiTube/enum'
import BiTubes from './products/BiTubes'
import { TubeProperties } from '../../../utils/StandardMTOEnum'

interface SingleProductEntryProps {}

const SingleProductEntry: React.FC<SingleProductEntryProps> = () => {
  const product = useProductFromQueryParam()
  const formik = useFormikHelper()
  const { validationAPI } = useTubeValidation()

  const [lastCursorPosition, setLastCursorPosition] = useState<number>(0)

  useEffect(() => {
    formik.setFieldValue('displayPageError', false, false)
    if (
      formik.selectedOligoValues?.sequence &&
      formik.selectedOligoValues?.sequence !== '' &&
      !formik.touched?.sequence
    ) {
      formik.setFieldTouched('sequence', true, false)
    }
  }, [])

  const insertModificationIntoSequence = async ({
    value,
    resetMod,
    isAntiSense,
    triggerValidate = true,
  }: InsertModificationArgs): Promise<string> => {
    const sequenceType = isAntiSense
      ? TubeProperties.AntiSenseSequence
      : TubeProperties.Sequence
    const sequence = formik.selectedOligoValues[sequenceType] || ''
    const sequenceWithBase = `${sequence.slice(
      0,
      lastCursorPosition
    )}${value}${sequence.slice(lastCursorPosition)}`
    const updatedSequence = formik.selectedOligoValues.insertAsterisk
      ? insertAsteriskBetweenCharacters(
          sequenceWithBase,
          !!formik.selectedOligoValues.fiveMod,
          !!formik.selectedOligoValues.threeMod
        )
      : sequenceWithBase

    formik.setOligoFieldValue(sequenceType, updatedSequence, false)
    if (!formik.touched?.[sequenceType]) {
      formik.setFieldTouched(sequenceType, true, false)
    }
    triggerValidate &&
      validationAPI({
        ...formik.validationFields,
        [sequenceType]: updatedSequence,
      })
    const newCursorPosition =
      lastCursorPosition +
      (formik.selectedOligoValues.insertAsterisk
        ? value.length + 1
        : value.length)
    setLastCursorPosition(
      newCursorPosition <= updatedSequence.length
        ? newCursorPosition
        : updatedSequence.length
    )
    resetMod && resetMod()
    return updatedSequence
  }

  const {
    Beacon,
    EasyOligo,
    iscaledna,
    LongOligo,
    Probe,
    PureSimple,
    Rna,
    Standard,
    Wellred,
  } = TubeProduct

  const { LightCycler, Duplex, FastDuplex, mirna } = BiTubeProduct
  const dnaTubesProducts: string[] = [
    Beacon,
    EasyOligo,
    iscaledna,
    LongOligo,
    Probe,
    PureSimple,
    Rna,
    Standard,
    Wellred,
  ]
  const biTubesProducts: string[] = [LightCycler, Duplex, FastDuplex, mirna]

  const loadProductBasedComponent = () => {
    if (dnaTubesProducts.includes(product)) {
      return (
        <DnaTubes
          setLastCursorPosition={setLastCursorPosition}
          insertModificationIntoSequence={insertModificationIntoSequence}
        />
      )
    } else if (biTubesProducts.includes(product)) {
      return (
        <BiTubes
          setLastCursorPosition={setLastCursorPosition}
          insertModificationIntoSequence={insertModificationIntoSequence}
        />
      )
    } else {
      return <></>
    }
  }

  return <>{loadProductBasedComponent()}</>
}

export default SingleProductEntry
